import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 18px;\n  cursor: pointer;\n  background-color: ', ';\n  width: 40px;\n  height: 40px;\n  line-height: 23px;\n'], ['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 18px;\n  cursor: pointer;\n  background-color: ', ';\n  width: 40px;\n  height: 40px;\n  line-height: 23px;\n']);

import React, { Component } from 'react';
import styled from 'styled-components';
import { Icon } from './..';
import { styles } from 'gipsy-misc';

var AddTagButton = function (_Component) {
  _inherits(AddTagButton, _Component);

  function AddTagButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AddTagButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddTagButton.__proto__ || Object.getPrototypeOf(AddTagButton)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function () {
      if (_this.props.onClick) {
        _this.props.onClick();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AddTagButton, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        PlusButton,
        { onClick: this.onClick },
        React.createElement(Icon, { icon: 'Plus', size: 15 })
      );
    }
  }]);

  return AddTagButton;
}(Component);

var PlusButton = styled.div(_templateObject, styles.colors.buttonLightColor);

export default AddTagButton;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/AddTagButton/index.js
// module id = 827
// module chunks = 0